import { ChangeDetectionStrategy, Component, Input } from "@angular/core";

import { BvLogoLoaderComponent } from "./logo-loader.component";

export type BvSpinnerSize = "sm" | "md" | "lg";

const SIZE_PX: Record<BvSpinnerSize, number> = {
  sm: 20,
  md: 32,
  lg: 48,
};

/**
 * Indeterminate loading spinner — renders the brand J9 "filling heart" loader.
 *
 *   <bv-spinner></bv-spinner>
 *   <bv-spinner size="sm"></bv-spinner>
 */
@Component({
    selector: "bv-spinner",
    template: "<bv-logo-loader [size]=\"sizePx\"></bv-logo-loader>",
    styleUrls: ["./spinner.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [BvLogoLoaderComponent],
    host: {
        class: "bv-spinner",
        role: "progressbar",
        "aria-label": "Loading",
    }
})
export class BvSpinnerComponent {
  @Input() size: BvSpinnerSize = "md";

  get sizePx(): number {
    return SIZE_PX[this.size];
  }
}
